// extracted by mini-css-extract-plugin
var _1 = "SmallPriceChartStyle-module__value___NZFnj";
var _2 = "SmallPriceChartStyle-module__value-green___NUaWV";
var _3 = "SmallPriceChartStyle-module__value-red___ukAQl";
var _4 = "SmallPriceChartStyle-module__value-green___NUaWV";
var _5 = "SmallPriceChartStyle-module__value-red___ukAQl";
export { _1 as "value", _2 as "value-green", _3 as "value-red", _4 as "valueGreen", _5 as "valueRed" }
